import { gql } from '@apollo/client';

export const GET_KEYS = gql`
  query GetApiKeys {
    keys {
      id
      value
      access
      type
      label
      hidden
    }
  }
`;

export const RENAME_KEY = gql`
  mutation RenameKey($id: String!, $label: String!) {
    updateKey(id: $id, label: $label) {
      id
      label
    }
  }
`;

export const ADD_KEY = gql`
  mutation AddApiKey($access: Access!, $label: String, $type: Type!) {
    createKey(access: $access, label: $label, type: $type) {
      id
      access
      label
      type
      value
      hidden
    }
  }
`;

export const DELETE_KEY = gql`
  mutation DeleteKey($id: String!) {
    deleteKey(id: $id) {
      id
    }
  }
`;
